import { SCHEDULES_ENDPOINT } from './constants';

export const makeSchedulesEndpoint = (scheduleId?: string) => {
  let endpoint = SCHEDULES_ENDPOINT;

  endpoint = endpoint.replace(':scheduleId', scheduleId || 'default');

  return endpoint as typeof SCHEDULES_ENDPOINT;
};
